import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import { Redirect, useLocation, withRouter, Link } from 'react-router-dom'
import OutsideClickHandler from 'react-outside-click-handler';

import { hasPermission } from '../../lib/components/form/RestrictedComponent';
import { track, EVENTS } from '../../lib/tracking';
const version = process.env.APP_VERSION

const UnstyledLink = props => {
    return <Link style={{ textDecoration: 'none', color: 'initial' }} {...props} />
}

const WorkspaceSideNav = props => {
    const [expanded, setExpanded] = useState(props.navExpanded)
    const [redirect, setRedirect] = useState(false)
    useEffect(() => {
        if (props.navExpanded != expanded) {
            setExpanded(props.navExpanded)
        }
    }, [props.navExpanded])
    const launchChatWidget = () => {
        var user = props.user.user;
        if (window.fcWidget) {
            var restoreId = null
            window.fcWidget.init({
                token: "5f33c0ac-167d-44f9-9db0-89ce70b3424a",
                host: "https://wchat.freshchat.com",
                externalId: user.clientId + '_' + user.userId,
                restoreId: restoreId ? restoreId : null,
                config: {
                    //showFAQOnOpen: true,
                    hideFAQ: false,
                    "cssNames": {
                        "widget": "custom_fc_frame"
                    },
                    actions: {
                        csat_yes: 'Yes, Resolved',
                        csat_no: 'No, Resolved',
                        push_notify_yes: 'Notify',
                        push_notify_no: 'No Notify',
                        tab_faq: 'Knowledge',
                        tab_chat: 'Message',
                        csat_submit: 'Submit Review Comments'
                    },

                    headerProperty: {
                        direction: 'ltr',
                        hideChatButton: true
                    }
                }
            });
            window.fcWidget.on("widget:loaded", function () {
                // console.log('widget loaded')

                window.fcWidget.on("unreadCount:notify", function (resp) {
                    // console.log(resp); //TODO: use badge at support for new messages OR notification at top
                });
                window.fcWidget.on("widget:closed", function () {

                });
                window.fcWidget.on("widget:opened", function (resp) {

                });
            });

            window.fcWidget.on("widget:closed", function () {
                // console.log('widget closed')
            });

            window.fcWidget.user.get(function (resp) {
                var status = resp && resp.status,
                    data = resp && resp.data;
                if (status !== 200) {
                    window.fcWidget.user.setProperties({
                        firstName: user.firstName, // user’s first name
                        lastName: user.lastName, // user’s last name
                        email: user.email, // user’s email address
                        InvUserID: user.userId,
                        ClientID: user.clientId
                    });
                    window.fcWidget.on('user:created', function (resp) {
                        var status = resp && resp.status,
                            data = resp && resp.data;
                        if (status === 200) {
                            if (data.restoreId) {
                                //TODO: Update restoreId in cookie or local storage
                            }
                        }
                    });
                }
            });
            window.fcWidget.open();
        }
    }
    const launchSupportChat = () => {
        window.fwSettings = { 'widget_id': 48000000042 };
        //load widget scripts
        const script = window.document.createElement("script");
        script.src = "https://widget.freshworks.com/widgets/48000000042.js";
        script.async = true;
        window.document.body.appendChild(script);
        if ("function" != typeof window.FreshworksWidget) { var n = function () { n.q.push(arguments) }; n.q = [], window.FreshworksWidget = n }
        var user = props.user.user;

        // Support/FAQ ticketing widget
        if (window.FreshworksWidget) {
            window.FreshworksWidget('identify', 'ticketForm', {
                name: user.firstName + ' ' + user.lastName,
                email: user.email
            });
            window.FreshworksWidget('prefill', 'ticketForm', {
                custom_fields: {
                    ClientID: user.clientId,
                    InvUserID: user.userId,
                    externalId: user.clientId + '_' + user.userId
                }
            });

            window.FreshworksWidget('hide', 'ticketForm', ['email']);
            // window.FreshworksWidget('close');
            window.FreshworksWidget('open');
            //setState({SupportBotOpen:true})
        }
    }
    const navToggle = () => {
        props.navToggle(!expanded)
        setExpanded(prev => !prev)
    }

    const { user } = props;
    const handleSelect = selected => {
        if (selected.indexOf("$") > -1) {
            switch (selected) {
                case '$launchTicket':
                    track(EVENTS.EXTERNAL_HELP, { target: 'support_ticket' });
                    launchSupportChat();
                    break;
                case '$launchChat':
                    if (user.client.supportLevel > 1) {
                        track(EVENTS.EXTERNAL_HELP, { target: 'support_chat' });
                        launchChatWidget();
                    } else {
                        alert('this feature is not enabled in your account, contact sales or support to upgrade');
                    }
                    break;
                case '$launchDocs':
                    //opens freshdesk support and docs portal in a new window
                    track(EVENTS.EXTERNAL_HELP, { target: 'docs_portal' });
                    window.open('https://invintus-support.freshdesk.com/support/solutions', '_blank');
                    break;
                default:
                //  ?? need to disable select
            }
        } else {
            props.history.push(selected)
            //   setRedirect(selected)
            // window.location = selected;
        }
    }

    return (
        <OutsideClickHandler
            onOutsideClick={() => {
                setExpanded(false)
                // setState({ expanded: false });
            }}
        >
            <SideNav
                className={expanded ? "sidenav---expanded" : "sidenav---unexpanded"}
                expanded={expanded}
                onToggle={() => navToggle()}
                onSelect={(selected) => { handleSelect(selected) }}
            >
                {redirect !== false ? <Redirect to={redirect} /> : null}
                {/* {props.navToggle} */}
                <SideNav.Toggle />
                <SideNav.Nav selected={useLocation().pathname}>
                    <NavItem eventKey="/" >
                        <NavIcon>
                            <UnstyledLink to="/">
                                <i className="fas fa-tachometer-alt fa-lg" style={{ fontSize: '1.75em' }} />
                            </UnstyledLink>
                        </NavIcon>
                        <NavText>
                            Dashboard
                        </NavText>
                    </NavItem>
                    {hasPermission("analytics.read") ? <NavItem eventKey="/analytics">
                        <NavIcon>
                            <UnstyledLink to="/analytics">
                                <i className="fas fa-chart-pie fa-lg" style={{ fontSize: '1.75em' }} />
                            </UnstyledLink>
                        </NavIcon>
                        <NavText>
                            Analytics
                        </NavText>
                    </NavItem> : null}
                    {(hasPermission("event.read") || hasPermission("agenda_event.read") || hasPermission("event.create")) ?
                        <NavItem eventKey="Events" data-testid="workspace-nav-events" onClick={hasPermission('event.read') ? () => handleSelect('/events') : () => {/* noop */ }}>
                            <NavIcon>
                                <UnstyledLink to="/events">
                                    <i className="far fa-list-alt fa-lg" style={{ fontSize: '1.75em' }} /> <i className="fas fa-ellipsis-v fa-xsm"></i>
                                </UnstyledLink>
                            </NavIcon>
                            <NavText>
                                Manage Events
                            </NavText>
                            {hasPermission("event.read") ? <NavItem eventKey="/events">
                                <NavText>
                                    <UnstyledLink to="/events">
                                        <i className="fa fa-list" /> Event List
                                    </UnstyledLink>
                                </NavText>
                            </NavItem> : null}
                            {hasPermission("agenda_event.read") ? <NavItem eventKey="/agenda">
                                <NavText>
                                    <UnstyledLink to="/agenda">
                                        <i className="fa fa-list-ol" /> Agenda Logger
                                    </UnstyledLink>
                                </NavText>
                            </NavItem> : null}
                            {hasPermission("event.create") ? <NavItem eventKey="/events/create">
                                <NavText>
                                    <UnstyledLink to="/events/create">
                                        <i className="far fa-calendar-plus" /> Create New
                                    </UnstyledLink>
                                </NavText>
                            </NavItem> : null}
                        </NavItem> : null}
                    {(hasPermission("manage_client_globalMedia.read") || hasPermission("manage_client_encoders.read")) ? <NavItem eventKey="Media Settings" >
                        <NavIcon>
                            <i className="fas fa-photo-video" style={{ fontSize: '1.75em' }} /> <i className="fas fa-ellipsis-v fa-xsm"></i>
                        </NavIcon>
                        <NavText>
                            Media Settings
                        </NavText>
                        {hasPermission("manage_client_globalMedia.read") ? <NavItem eventKey="/manage/media">
                            <NavText>
                                <UnstyledLink to="/manage/media">
                                    <i className="fas fa-film fa"></i> Global Media Library
                                </UnstyledLink>
                            </NavText>
                        </NavItem> : null}
                        {hasPermission("manage_client_encoders.read") ? <NavItem eventKey="/manage/encoders">
                            <NavText>
                                <UnstyledLink to="/manage/encoders">
                                    <i className="fas fa-video fa"></i> Live Video Sources
                                </UnstyledLink>
                            </NavText>
                        </NavItem> : null}
                        {hasPermission("manage_client_encoders.read") ? <NavItem eventKey="/sourceMultiViewer">
                            <NavText>
                                <UnstyledLink to="/sourceMultiViewer">
                                    <i className="fas fa-grip-horizontal"></i> Source MultiViewer
                                </UnstyledLink>
                            </NavText>
                        </NavItem> : null}
                    </NavItem> : null}
                    {
                        (
                            hasPermission("manage_client_playerSettings.read") ||
                            hasPermission("manage_client_channelSettings.read") ||
                            hasPermission("manage_ott.read") ||
                            hasPermission("manage_ads.read")
                        ) ? <NavItem eventKey="Delivery Settings">
                                <NavIcon>
                                    {/* a custom Icon */}
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAACXBIWXMAAAsSAAALEgHS3X78AAAA+ElEQVRIieVUwQ2DMAw8V/zLCIzQDUpX6ASMwAiMwAiM0BHoBoxQNqD/Sq6CksoQg0JLXrV0EtjGl1MOEzODiBJECGZ+mamteY6EluzgaHGIORx/R3AB0HvZgAhykLEzgBRArdVXsFqcEDgAyAE8tD4FatKDJBBqblrvDF5ChUJQAhi0XonNK4KIMgANgLNI91bNYN+NugLAcZOChVNXc3VCZRVMsLCzitnATCHxPgpFrQwz6vK9CFKFwNXKXwna2T/hIHsae9nepW0l0OoOXWLtVHp+XI9OVO/iWVr3Oa4VzV7fQpzcrJHTmItAYOz8McDeBNdJjhlvHsYjkgPJq7oAAAAASUVORK5CYII="
                                        style={{ fontSize: '1.75em' }} /> <i className="fas fa-ellipsis-v fa-xsm"></i>
                                </NavIcon>
                                <NavText>
                                    Delivery Settings
                                </NavText>
                                {hasPermission("manage_client_playerSettings.read") ? <NavItem eventKey="/manage/player">
                                    <NavText>
                                        <UnstyledLink to="/manage/player">
                                            <i className="far fa-circle-play x1" aria-hidden="true"></i> Player Settings
                                        </UnstyledLink>
                                    </NavText>
                                </NavItem> : null}
                                {hasPermission("manage_client_channelSettings.read") ? <NavItem eventKey="/manage/listing">
                                    <NavText>
                                        <UnstyledLink to="/manage/listing">
                                            <i className="fas fa-th-list x1" aria-hidden="true"></i> Channel Settings
                                        </UnstyledLink>
                                    </NavText>
                                </NavItem> : null}
                                {hasPermission("manage_ott.read") ? <NavItem eventKey="/manage/ott">
                                    <NavText>
                                        <UnstyledLink to="/manage/ott">
                                            <i className="fas fa-tv x1"></i> OTT Settings
                                        </UnstyledLink>
                                    </NavText>
                                </NavItem> : null}
                                {hasPermission("manage_ads.read") ? <NavItem eventKey="/manage/ads">
                                    <NavText>
                                        <UnstyledLink to="/manage/ads">
                                            <i className="fas fa-ad x1"></i> Ad Campaigns
                                        </UnstyledLink>
                                    </NavText>
                                </NavItem> : null}
                                <NavItem eventKey="/manage/vocab">
                                    <NavText>
                                        <UnstyledLink to="/manage/vocab">
                                            <i className="fas fa-book"></i> Vocabulary
                                        </UnstyledLink>
                                    </NavText>
                                </NavItem>
                            </NavItem> : null}
                    {(
                        hasPermission("event_importer.read") ||
                        hasPermission("manage_client_categories.read") ||
                        hasPermission("manage_client_keywords.read") ||
                        hasPermission("manage_client_locations.read") ||
                        hasPermission("account_contentGroups.read")
                    ) ? <NavItem eventKey="Metadata Settings" data-testid="workspace-nav-metadata">
                            <NavIcon>
                                <i className="fas fa-toolbox fa-lg" style={{ fontSize: '1.75em' }} /> <i className="fas fa-ellipsis-v fa-xsm"></i>
                            </NavIcon>
                            <NavText>
                                Metadata Settings
                            </NavText>
                            {hasPermission("event_importer.read") ? <NavItem eventKey="/import">
                                <NavText>
                                    <UnstyledLink to="/import">
                                        <i className="fas fa-file-import x1" aria-hidden="true"></i> Bulk Event Import
                                    </UnstyledLink>
                                </NavText>
                            </NavItem> : null}
                            {hasPermission("manage_client_categories.read") ? <NavItem eventKey="/manage/categories">
                                <NavText>
                                    <UnstyledLink to="/manage/categories">
                                        <i className="fas fa-sitemap x1"></i> Categories
                                    </UnstyledLink>
                                </NavText>
                            </NavItem> : null}
                            {hasPermission("account_contentGroups.read") ? <NavItem eventKey="/contentGroups">
                                <NavText>
                                    <UnstyledLink to="/contentGroups">
                                        <i className="fas fa-project-diagram"></i> Content Groups
                                    </UnstyledLink>
                                </NavText>
                            </NavItem> : null
                            }
                            {hasPermission("manage_client_keywords.read") ? <NavItem eventKey="/manage/keywords" >
                                <NavText>
                                    <UnstyledLink to="/manage/keywords" data-testid="workspace-nav-keywords">
                                        <i className="fas fa-tag x1"></i> Keywords
                                    </UnstyledLink>
                                </NavText>
                            </NavItem> : null}
                            {hasPermission("manage_client_locations.read") ? <NavItem eventKey="/manage/locations">
                                <NavText>
                                    <UnstyledLink to="/manage/locations">
                                        <i className="fas fa-map-marker-alt x1"></i> Locations
                                    </UnstyledLink>
                                </NavText>
                            </NavItem> : null}
                            {/* <NavItem eventKey="$soon">
                      <NavText>
                          <span className="label label-info ">coming soon</span><br />
                          <i className="fas fa-file-signature x1"></i> Transcript Dictionary
                      </NavText>
                    </NavItem> */}

                        </NavItem> : null}
                    <NavItem eventKey="Manage Accounts">
                        <NavIcon>
                            <i className="fas fa-user-cog fa-lg" style={{ fontSize: '1.75em' }} />  <i className="fas fa-ellipsis-v fa-xsm"></i>
                        </NavIcon>
                        <NavText>
                            Account / Technicians
                        </NavText>
                        {hasPermission("account.read") ? <NavItem eventKey="/account">
                            <NavText>
                                <UnstyledLink to="/account">
                                    <i className="far fa-user-circle x1"></i> Account
                                </UnstyledLink>
                            </NavText>
                        </NavItem> : null}
                        {hasPermission("account_securityGroups.read") ? <NavItem eventKey="/securityGroups">
                            <NavText>
                                <UnstyledLink to="/securityGroups">
                                    <i className="fas fa-shield-alt"></i> Users
                                </UnstyledLink>
                            </NavText>
                        </NavItem> : null}
                        {hasPermission("manage_client_technicians.read") ? <NavItem eventKey="/manage/technicians">
                            <NavText>
                                <UnstyledLink to="/manage/technicians">
                                    <i className="fas fa-portrait x1"></i> Technicians
                                </UnstyledLink>
                            </NavText>
                        </NavItem> : null}
                        <NavItem eventKey="/logout">
                            <NavText>
                                <UnstyledLink to="/logout">
                                    <i className="fas fa-sign-out-alt x1"></i> Logout
                                </UnstyledLink>
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem eventKey="Help">
                        <NavIcon>
                            <i className="fa fa-question-circle fa-lg" style={{ fontSize: '1.75em' }} />  <i className="fas fa-ellipsis-v fa-xsm"></i>
                        </NavIcon>
                        <NavText>
                            Help / Support / Docs
                        </NavText>
                        <NavItem
                            eventKey="$launchChat"
                            navitemClassName={(user.client.supportLevel > 1) ? '' : 'sidenav--disabled'}
                        >
                            <NavText>
                                <i className="fas fa-headset xs"></i><span> Live Chat Support</span>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="$launchTicket">
                            <NavText>
                                <i className={"fas fa-ticket-alt xs "}></i> Support Ticket
                          </NavText>
                        </NavItem>
                        {/* <NavItem eventKey="$launchDocs">
                          <NavText>
                              Documentation <i className="fas fa-external-link-alt xs"></i>
                          </NavText>
                      </NavItem> */}
                        <NavItem eventKey="/status">
                            <NavText>
                                <UnstyledLink to="/status">
                                    <span><i className="fas fa-file-medical-alt"></i> System Status</span>
                                </UnstyledLink>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="/release-notes">
                            <NavText>
                                <UnstyledLink to="/release-notes">
                                    <span><i className="fas fa-stream"></i> Release Notes</span>
                                </UnstyledLink>
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="/help">
                            <NavText>
                                <a style={{color: 'initial', textDecoration: 'none'}} onClick={e => e.stopPropagation()} href="https://invintus-support.freshdesk.com/support/solutions" target="_blank">
                                    Documentation <i className="fas fa-external-link-alt xs"></i>
                                </a>
                            </NavText>
                        </NavItem>
                    </NavItem>
                    {window.location.hostname.contains("localhost") ? <div style={{marginBottom: '1rem'}} className='version'>local</div> : null}
                    {window.location.hostname.contains("stage") ? <div style={{marginBottom: '1rem'}} className='version'>Staging</div> : null}
                    <div className='version'>v{version}</div>
                </SideNav.Nav>
            </SideNav>
        </OutsideClickHandler>
    )
}

export default withRouter(WorkspaceSideNav)
